"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _grommet = require("grommet");

var _ErrorPopupModule = _interopRequireDefault(require("./ErrorPopup.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ErrorPopup = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorPopup, _React$Component);

  var _super = _createSuper(ErrorPopup);

  function ErrorPopup() {
    _classCallCheck(this, ErrorPopup);

    return _super.apply(this, arguments);
  }

  _createClass(ErrorPopup, [{
    key: "render",
    value: function render() {
      /*
      if(this.props.tablet) {
          return (
              <Layer style={{background: "none"}} onEsc={this.props.closePopup} onClickOutside={this.props.closePopup}>
                  <Box className={styles.outerDiv_tablet}>
                      <Box className={styles.header}>
                          <div className={styles.headerText}>{this.props.title}</div>
                      </Box>
                      <div className={styles.message}>{this.props.message}</div>
                      <button className={styles.acceptButton} onClick={this.props.closePopup}>Cancel</button>
                  </Box>
              </Layer>
          )
      } 
      if(this.props.mobile) {
          return (
              <Layer style={{background: "none", width: "calc(100% - 30px)", left: "15px", height: "300px", top: "calc(50% - 150px"}} onEsc={this.props.closePopup} onClickOutside={this.props.closePopup}>
                  <Box  className={styles.outerDiv_mobile}>
                      <Box className={styles.header}>
                          <div className={styles.headerText}>{this.props.title}</div>
                      </Box>
                      <div className={styles.message}>{this.props.message}</div>
                      <button className={styles.acceptButton} onClick={this.props.closePopup}>Cancel</button>
                  </Box>
              </Layer>
          )
      } */
      return /*#__PURE__*/_react["default"].createElement(_grommet.Layer, {
        style: {
          background: "none"
        },
        onEsc: this.props.closePopup,
        onClickOutside: this.props.closePopup
      }, /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
        className: _ErrorPopupModule["default"].outerDiv
      }, /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
        className: _ErrorPopupModule["default"].header
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErrorPopupModule["default"].headerText
      }, this.props.title)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErrorPopupModule["default"].message
      }, this.props.message), /*#__PURE__*/_react["default"].createElement("button", {
        className: _ErrorPopupModule["default"].acceptButton,
        onClick: this.props.closePopup
      }, "Cancel")));
    }
  }]);

  return ErrorPopup;
}(_react["default"].Component);

var _default = ErrorPopup;
exports["default"] = _default;

//# sourceMappingURL=ErrorPopup.js.map